export function schedulingHistory() {
	const storageKey = 'scheduleHistory';
	function push(stackItem) {
		if (typeof (stackItem.state.model.pushToHistory !== 'undefined') && !stackItem.state.model.pushToHistory) {
			console.log('NOT PUSHING to history');
			return;
		}

		console.log('PUSHING to history', stackItem);
		let stack = [];
		try {
			stack = JSON.parse(localStorage.getItem(storageKey)) || [];
		} catch {
			console.error(`Issue with corrupted scheduling history`);
			stack = [];
		}
		if (!stack.length) {
			stackItem.initial = true;
		}
		stack.push(stackItem);

		localStorage.setItem(storageKey, JSON.stringify(stack));
	}

	function top() {
		let stack = [];
		try {
			stack = JSON.parse(localStorage.getItem(storageKey));
		} catch {
			console.error(`Issue with corrupted scheduling history`);
			stack = [];
		}
		if (!stack || !stack.length) {
			return null;
		} else {
			const stackItem = stack[stack.length - 1];
			return stackItem;
		}
	}

	function pop() {
		let stack = [];
		try {
			stack = JSON.parse(localStorage.getItem(storageKey));
		} catch {
			console.error(`Issue with corrupted scheduling history`);
			stack = [];
		}
		if (!stack || !stack.length) {
			return null;
		} else {
			const stackItem = stack.pop();
			//update stack in storage
			localStorage.setItem(storageKey, JSON.stringify(stack));

			return stackItem;
		}
	}

	function clear() {
		let stack = [];
		localStorage.setItem(storageKey, JSON.stringify(stack));
	}

	function get() {
		let stack = [];
		try {
			stack = JSON.parse(localStorage.getItem(storageKey));
		} catch {
			console.error(`Issue with corrupted scheduling history`);
			stack = [];
		}
		if (!stack || !stack.length) {
			return null;
		} else {
			return stack;
		}
	}

	return {
		push,
		pop,
		top,
		clear,
		get,
	};
}
